import Work from './Work'
import './Work.scss'

export default Work
